import type { AsyncState } from '../../store/types';

const FETCH_APP_SETTINGS_BEGIN = 'account/shared/FETCH_APP_SETTINGS_BEGIN';
const FETCH_APP_SETTINGS_SUCCESS = 'account/shared/FETCH_APP_SETTINGS_SUCCESS';
const FETCH_APP_SETTINGS_FAILURE = 'account/shared/FETCH_APP_SETTINGS_FAILURE';
const UPDATE_APP_SETTINGS = 'account/shared/UPDATE_APP_SETTINGS';

export type Account2Config = {
  financingTerms: {
    shouldShowFinancingTermsTab: boolean;
  };
  notificationSettings: {
    shouldShowEmail: boolean;
    shouldShowNotificationSettingsTab: boolean;
    shouldShowPhoneCall: boolean;
    shouldShowSms: boolean;
    shouldShowTCPA: boolean;
  };
  referrals: {
    shouldShowReferralsTab: boolean;
  };
};

type AppSettings = {
  Account2Config: Account2Config;
};

export type SharedState = {
  appSettings: AppSettings;
  getAppSettings: AsyncState;
};

export {
  FETCH_APP_SETTINGS_BEGIN,
  FETCH_APP_SETTINGS_SUCCESS,
  FETCH_APP_SETTINGS_FAILURE,
  UPDATE_APP_SETTINGS
};
